import { useEffect, useState } from 'react'
import { useDispatch } from "react-redux"
import { setAdditionalSubHdView, setSubHeading } from "../../store/reducers/CommonReducer"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import { CC_PRODUCT_ID, TOKEN_2 } from "../../utils/Constants"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL, CONFIG_DATA_URL } from "../../utils/Config"
import { formatDictString, getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"
import RadioButton from '../common/RadioButton'
import ListBox from '../common/ListBox'
import { Button } from 'antd'
import UMCButton from '../common/UMCButton'
import { Divider } from 'antd'
import { DARK_GRAY } from "../../styles/styleUtils"
import TabExtraContent from '../common/TabExtraContent'
import CustomDialog from './CustomDialog'
import getData from './GetData'
import parse from 'html-react-parser'

//========================
// Profile selection page
//========================
const ProfileSelection = ({ onPrevious, onNext, activeProfile, selectedProfile, prerequisites, currentType, setCurrentType }) => {
    const [items, setItems] = useState([]);

    // List of profiles stored in the database
    const [profileList, setProfileList] = useState([]);

    // Message part
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [message, setMessage] = useState([]);

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const language = useSelector((state) => state.common.language);

    // Radio buttons definition (initially they are all disabled and will be activated according to the list of profiles)
    const PROFILE_TYPE = [
        {
            label: "LABEL_PUBLIC",
            value: "public",
            help: "MSG_PUBLIC",
            disabled: 1
        },
        {
            label: "LABEL_VISUAL_AA",
            value: "Visual AA",
            help: "MSG_VISUAL_AA",
            disabled: 1,
        },
        {
            label: "LABEL_VISUAL_NA",
            value: "Visual NA",
            help: "MSG_VISUAL_NA",
            disabled: 1
        },
        {
            label: "LABEL_WEBRTC",
            value: "WebRTC",
            help: "MSG_WEBRTC",
            disabled: 1
        },
        {
            label: "LABEL_DISPATCH_CON",
            value: "Dispatch",
            help: "MSG_DISPATCH_CON",
            disabled: 1
        },
    ];

    const [profileType, setProfileType] = useState(PROFILE_TYPE);

    // Initialize link table in case of no response from back end (points probably to old documentation 20/10/2025)
    const [linksListFromDB, setLinksListFromDB] = useState(
        [
            {
                id: "MSG_VISUAL_AA",
                link: "https://myportal.al-enterprise.com/a4F5I000000Y9e6UAC"
            },
            {
                id: "MSG_VISUAL_NA",
                link: "https://myportal.al-enterprise.com/a4F5I000000YOQlUAO"
            },
            {
                id: "MSG_WEBRTC",
                link: "https://myportal.al-enterprise.com/a4F5I000000UPX0UAO"
            },
            {
                id: "MSG_DISPATCH_CON",
                link: "https://myportal.al-enterprise.com/a4F5I000000HMZsUAO"
            }
        ]
    );

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()))
    }, [language]);

    // Retrieve URLs from backend (labels)
    useEffect(() => {
        const fetchLinks = async (identifier) => {
            var url, headerSection, response;

            try {
                url = CONFIG_DATA_URL + "/labeldata/" + identifier;
                headerSection = { headers: { "Authorization": `Bearer ${getSessionItem(TOKEN_2)}` } };
                //dispatch(setContentLoading(true));
                response = await getData(url, headerSection, profileTypeHandler);
                //dispatch(setContentLoading(false));
            }
            catch (e) {
                console.error(e);
                dispatch(setContentLoading(false));
            }
        }
        dispatch(setContentLoading(true));
        linksListFromDB.forEach(element => {
            fetchLinks(element.id);
        });
        dispatch(setContentLoading(false));
    }, []);

    // Profile type handler to fill the URL table
    const profileTypeHandler = (resp) => {
        if (resp.label && resp.data) {
            const idToUpdate = resp.label;
            const newLink = resp.data;
            setLinksListFromDB(prevList =>
                prevList.map(item =>
                    item.id === idToUpdate
                        ? { ...item, link: newLink }
                        : item
                )
            );
        }
    }

    useEffect(() => {
        dispatch(setSubHeading(getTranslated(dict, "LABEL_CREATE_SIP_TRUNK")));

        // Update the URLs pointing to the documentation of Radiobuttons tooltips
        if (linksListFromDB) {
            const tempProfType = profileType.map(profileType => {
                const linkItem = linksListFromDB.find(linkItem => linkItem.id === profileType.help)
                if (linkItem) {
                    return {
                        ...profileType,
                        help: formatDictString(dict, profileType.help, { link: linkItem?.link })
                    }
                }
                return { ...profileType }
            })
            setProfileType(tempProfType)
        }
    }, [dict, linksListFromDB, dispatch]);

    // Profile list handler
    const profileListHandler = (data) => {
        setProfileList(data);
    }

    useEffect(() => {
        var ccproductid = getSessionItem(CC_PRODUCT_ID);

        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()));

        const fetchData = async () => {
            var url, headerSection, response;

            try {
                url = SIP_URL + "/sipprofiles/" + ccproductid;
                headerSection = { headers: { "Authorization": `Bearer ${getSessionItem(TOKEN_2)}` } };
                dispatch(setContentLoading(true));
                response = await getData(url, headerSection, profileListHandler);
                dispatch(setContentLoading(false));
            }
            catch (e) {
                console.error(e);
                dispatch(setContentLoading(false));
            }
        };

        if (profileList.length === 0) {
            fetchData();
        }

        // Suppress previous selection
        selectedProfile({});
    }, []);

    useEffect(() => {
        if (profileList.length !== 0) {
            getProfileType();
            setItems(getCurrentProfileList(currentType));
        }
    }, [profileList]);

    // Adjust the SIP profile list to be conform with the JSON expected from listBox
    function conformObj(obj) {
        obj['value'] = obj['name'];
        delete obj['name'];
        obj['label'] = obj['value'];
        obj['key'] = obj['id'];
        delete obj['id'];

        return obj;
    }

    // Filter the global list to only retrieve the profile type selected by radio button
    const getCurrentProfileList = (prop) => {
        var workingList = [];

        // clone the JSON profile list
        workingList = JSON.parse(JSON.stringify(profileList));
        let filteredPrf = workingList.filter((prf) => prf.type === prop);
        //filteredPrf.forEach(obj => conformObj(obj, 'name', 'value'));
        filteredPrf.map(obj => conformObj(obj, 'name', 'value'));
        return filteredPrf;
    }

    // Enable the radio buttons which have at least one profile available
    const getProfileType = () => {
        var radioDisabled = profileType;
        const tmpMap = profileList.map((entry) => {
            switch (entry.type) {
                case "public": radioDisabled[0].disabled = 0;
                    break;
                case "Visual AA": radioDisabled[1].disabled = 0;
                    break;
                case "Visual NA": radioDisabled[2].disabled = 0;
                    break;
                case "WebRTC": radioDisabled[3].disabled = 0;
                    break;
                case "Dispatch": radioDisabled[4].disabled = 0;
                    break;
                default: break;
            }
            return entry;
        });
        setProfileType(radioDisabled);
        return tmpMap;
    }

    // Find matching profile parameters from the selected profile
    const FindItem = (val) => {
        var foundItem = items.find(item => item.label === val)
        if (foundItem) {
            return foundItem;
        }
        return {};
    }

    const getExtraSubHeaderContent = () => {
        return <TabExtraContent
            contentItems={["document", "help"]}
            documentButtonText={getTranslated(dict, "LABEL_SIP_PROVIDER")}
            handleDocument={() => {
                window.open(`https://myportal.al-enterprise.com/a4F5I000000YOGMUA4`, "_blank")
            }}
            handleHelpReq={() => {
                // code to handle help doc action
                let src = `/hol/oxe/oxe-${language}/dita/topics/umc_EN_DE_ES_FR/umc_easy-sip-trunk-creation.html`
                window.open(`${src}#Create-trunk__Profile-Selection`, "_blank")
            }}
        />
    }

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // Verify OXE configuration against parameters required in selected profile
    //
    // country code in OXE | cc needed in profil |  result
    // ---------------------------------------------------
    //         0           |         0           | ok 
    //         0           |         1           | error 
    //         1           |         1           | ok   
    //         1           |         0           | ?????? for the moment ok 	
    //
    function VerifyPrerequisites() {
        var errmsg, msg, prereq_error = false;

        if (prerequisites) {
            prerequisites.forEach(preReq => {
                if (preReq.parameter === "COUNTRY_CODE") {
                    if (preReq.isExisting !== true) {   // No country code in OXE
                        if (activeProfile.useCountryCode === true) { // country code requested in profile
                            errmsg = getTranslated(dict, "MSG_ERROR_COUNTRY_CODE_NOT_SET");
                            errmsg += "<br/><small style='color: #5050F0;'>System&nbsp;>&nbsp;Other&nbsp;System&nbsp;Param.&nbsp;> Signaling&nbsp;String: SG&nbsp;Country&nbsp;code</small>";
                            msg = parse(errmsg);
                            prereq_error = true;
                        }
                    }
                    else {   // Country code configured in OXE
                        if (activeProfile.useCountryCode === false) { // country code not requested in profile

                        }
                    }
                }
            });
        }
        else {
            console.log("Prerequisites error (2).")
        }
        if (prereq_error === true) {
            setMessage(msg);
            showModal();
        }
        else {
            onNext();
        }
    }

    return (<>
        <div>
            <Divider orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, padding: "0 0 10px 0" }}>
                {getTranslated(dict, "LABEL_CHOOSE_TYPE")}
            </Divider>
            <RadioButton
                direction="vertical"
                value={currentType}
                options={profileType}
                tooltipWidth="150%"
                handleChange={(value) => {
                    //code to handle the radio btn selection
                    setItems(getCurrentProfileList(value));
                    setCurrentType(value);
                }}
            />
        </div>
        <div>
            <Divider orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, padding: "0 0 10px 0" }}>
                {getTranslated(dict, "LABEL_CHOOSE_PROFILE")}
            </Divider>
            <ListBox
                className="sip-listbox"
                listItems={items}
                width="100%"
                placeholder={getTranslated(dict, "PH_SEARCH_PROVIDER")}
                handleListBoxSelect={(val) => {
                    // Handle ListBox selection
                    let profile = { id: FindItem(val).key, name: val, type: FindItem(val).type, docRef: FindItem(val).docRef, docUrl: FindItem(val).docUrl, useCountryCode: FindItem(val).useCountryCode, sipMoveToTcp: FindItem(val).sipMoveToTcp };
                    selectedProfile(profile);
                }}
            />
        </div>
        <div className="sip-nav-buttons profile-span">
            <UMCButton
                className="sip-navigation-button sip-navigation-back sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_BACK")}
                type="primary"
                onClick={onPrevious}
                disabled={false} />
            <UMCButton
                className="sip-navigation-button sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_NEXT")}
                type="primary"
                onClick={VerifyPrerequisites}
                disabled={activeProfile.name === undefined} />
        </div>
        <CustomDialog
            title={getTranslated(dict, "LABEL_PREREQUISITES_TITLE")}
            open={isModalOpen}
            footer={<Button key="cancel" type="primary" onClick={handleCancel} className="sip-modal-btn" >
                {getTranslated(dict, "LABEL_CLOSE")}
            </Button>}
            type={"Error"}
            onCancel={handleCancel}
            width={"420px"}
        >
            {message}
        </CustomDialog>
    </>);
}

export default ProfileSelection;